'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var structuredClone = require('@ungap/structured-clone');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var structuredClone__default = /*#__PURE__*/_interopDefaultLegacy(structuredClone);

const stripPropertiesFromObject = (obj, properties) => {
    const copy = structuredClone__default["default"](obj);
    properties.forEach((nestedPropertyStr) => {
        const nestedProperties = nestedPropertyStr.split('.');
        const propertyToRemove = nestedProperties[nestedProperties.length - 1];
        const nestedObject = nestedProperties.length === 1
            ? copy
            : nestedProperties
                .slice(0, nestedProperties.length - 1)
                .reduce((acc, property) => acc[property], copy);
        if (nestedObject) {
            delete nestedObject[propertyToRemove];
        }
    });
    return copy;
};

exports.stripPropertiesFromObject = stripPropertiesFromObject;
//# sourceMappingURL=strip-properties-from-object.js.map
